// add lazy-load supported
import LazyLoad from "vanilla-lazyload";
let myLazyLoad = new LazyLoad();

// to top
function scrollTo(to, duration = 700) {
    const
        element = document.scrollingElement || document.documentElement,
        start = element.scrollTop,
        change = to - start,
        startDate = +new Date(),
        // t = current time
        // b = start value
        // c = change in value
        // d = duration
        easeInOutQuad = function (t, b, c, d) {
            t /= d / 2;
            if (t < 1) return c / 2 * t * t + b;
            t--;
            return -c / 2 * (t * (t - 2) - 1) + b;
        },
        animateScroll = function () {
            const currentDate = +new Date();
            const currentTime = currentDate - startDate;
            element.scrollTop = parseInt(easeInOutQuad(currentTime, start, change, duration));
            if (currentTime < duration) {
                requestAnimationFrame(animateScroll);
            } else {
                element.scrollTop = to;
            }
        };
    animateScroll();
}

document.addEventListener('DOMContentLoaded', function () {
    const header = document.querySelector(".header-fixed");
    const btn = document.querySelector("#toTop");
    const panel = document.querySelector(".footer-panel");
    const footer = document.querySelector(".footer");

    const handleScroll = () => {
        const scrolled = window.scrollY > 100;

        if (header) {
            header.classList.toggle("fixed", scrolled);
        }

        if (btn) {
            btn.classList.toggle("show", scrolled);
        }

        if (panel && footer.classList.contains('is-bottom-panel')) {
            const scrollPosition = window.innerHeight + window.scrollY;
            const pageHeight = document.documentElement.scrollHeight - 250;

            const scrolledToBottom = scrollPosition >= pageHeight;

            panel.classList.toggle("unfixed", scrolledToBottom);
        }
    };

    window.addEventListener("scroll", handleScroll);

    if (btn) {
        btn.onclick = (e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
        };
    }
});

// mobile burger menu
let burger = document.querySelector('.burger');
let menu_body = document.querySelector('.menu');
if (burger) {
    burger.onclick = function () {
        menu_body.classList.toggle('active');
        burger.classList.toggle('active')
    }
}

// adaptive table class
function coverTable() {
    let table = document.querySelectorAll('table');
    for (let i = table.length - 1; i >= 0; i--) {
        let cover = document.createElement('div');
        cover.classList.add('cover-table');
        table[i].parentNode.insertBefore(cover, table[i]);
        cover.appendChild(table[i]);
    }
}

coverTable();


// faq
const faq_container = document.querySelector('.faq-container');
if (faq_container) {
    faq_container.addEventListener('click', function (e) {
        const items = document.querySelectorAll('.faq-container-content')
        const target = e.target
        Array.from(items).forEach(item => {
            if (item != target) {
                item.classList.remove('show')
            }
        })
        target.classList.toggle('show')
    })
}

// iframe on click
(function() {
    'use strict';

    function loadGames() {
        let wraps = document.querySelectorAll('.js-game');

        wraps.forEach((wrap) => {
            let btn = wrap.querySelector('button');

            if (btn) {
                btn.addEventListener('click', function onClick() {
                    let frame = document.createElement('iframe');
                    let src = wrap.getAttribute('data-game');

                    frame.setAttribute('src', src);
                    btn.removeEventListener('click', onClick);
                    wrap.querySelector('.iframe__entry').innerHTML = '';
                    wrap.appendChild(frame);
                });
            }
        });
    }

    function toggleFullScreen(fullScreen) {
        if (!fullScreen) return;
        fullScreen.closest('.iframe').classList.toggle('active');
    }

    document.querySelectorAll('.iframe__full-screen').forEach((btn) => {
        btn.addEventListener('click', () => toggleFullScreen(btn));
    });

    loadGames();
})();

// import custom scripts
import './custom-app'
